import { useEffect, type FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ComprobantePDF: FC = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (uuid) navigate(`/comprobante/descarga/${uuid}?dl=pdf`, { replace: true });
  }, [uuid, navigate]);
  return null;
};

export default ComprobantePDF;
